export class EditMatchedLeadsProductHiringStates {
    ids: string[];
}